export function errorToString(err: unknown): string {
  return err instanceof Error ? err.message : "Erro desconhecido.";
}

export function pushBlobToDownload(filename: string, data: Blob) {
  const href = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = href;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(href);
}
